module.exports = __webpack_public_path__ + "img/profile-03.368d94ab.png";